import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import api from 'src/axios';

type Variables = {
  sessionId: string;
  skus: string[];
};

export const useAddProductsToSession = (
  options?: Omit<UseMutationOptions<void, Error, Variables>, 'mutationFn'>,
): UseMutationResult<void, Error, Variables> => {
  return useMutation({
    mutationFn: async ({ sessionId, skus }: Variables) => {
      const { data } = await api.post(
        `/sales-forecasting-sessions/${sessionId}/products`,
        { skus },
      );
      return data;
    },
    ...options,
  });
};
